import { useState, useEffect } from 'react';

const useLanguage = () => {
    // Initialize the current language from localStorage or default to 'It'
    const [currentLang, setCurrentLang] = useState(localStorage.getItem('SA_user_lang') || 'It');

    useEffect(() => {
        // Define the function that handles changes in localStorage
        const handleStorageChange = () => {
            const lang = localStorage.getItem('SA_user_lang') || 'It';
            setCurrentLang(lang); // Update the state with the new language
        };

        // Listen for changes to localStorage
        window.addEventListener('storage', handleStorageChange);

        // Cleanup the event listener when the component is unmounted
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []); // Empty dependency array means this effect runs only once on mount

    return currentLang;
};

export default useLanguage;